<template>
	<div class="case-settings">

		<InputGroup
			title="Change Primary Surgeon"
			desc="This is the primary owner of the case. Only user who are tagged as Surgeons can be selected here."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			v-if="availableSurgeons != null"
			>

			<MultiSelect
				v-model="caseForm.user"
				:options="enrichedSurgeons"
				:singleSelectionOnly="true"
				:showAsTags="['case_relation']"
				/>
				
		</InputGroup>
		
		<InputGroup
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>
			<InputText
				label="Order Number"
				type="text"
				v-model="caseForm.enquiry_number"
				autocomplete="disabled"
				:darkMode="true"
				/>
		</InputGroup>

		<InputGroup
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>
			<InputText
				label="Patient Reference"
				type="text"
				v-model="caseForm.patient_reference"
				autocomplete="disabled"
				:darkMode="true"
				/>
		</InputGroup>

		<InputGroup
			title="Set Status"
			desc="Once you have reviewed the enquiry, you can set the status to accepted or rejected."
			:darkMode="true"
			:oneColumn="true"
			:skipWhiteBox="true"
			>
			<InputFancyRadio 
				label="Status"
				:options="statusOptions"
				id="privilegelevel"
				v-model="caseForm.status"
				:darkMode="true"
				/>
		</InputGroup>

		

		<InputGroup
			title=""
			desc=""
			:skipWhiteBox="true"
			:noLine="true"
			:oneColumn="true"
			:fixedToBottom="true"
			>
			<Button
				label="Save"
				color="green"
				size="large"
				icon="save" 
				@click="submitCaseSettings"
				/>
		</InputGroup>

	</div>
</template>

<script>

import InputGroup from "@/Components/InputGroup"
import InputText from "@/Components/InputText"
import InputFancyRadio from "@/Components/InputFancyRadio"
import Button from "@/Components/Button"
import MultiSelect from "@/Components/MultiSelect"

export default {
	props: [
		'thisCase',
		'availableSurgeons'
	],
	components: {
		InputGroup,
		InputText,
		InputFancyRadio,
		Button,
		MultiSelect
	},
	data: () => {
		return {
			caseForm: {
				enquiry_number: '',
				patient_reference: '',
				status: '',
				user: ''
			},
			statusOptions: [
				{
					value: 'review',
					text: 'In Review'
				},
				{
					value: 'accepted',
					text: 'Accepted'
				},
				{
					value: 'rejected',
					text: 'Rejected'
				},
			],
		}
	},
	mounted(){
		this.caseForm.enquiry_number = this.thisCase.enquiry_number
		this.caseForm.patient_reference = this.thisCase.patient_reference
		this.caseForm.status = this.thisCase.status
		this.caseForm.user = this.thisCase.user_id
	},
	methods: {
		submitCaseSettings(){
			let reqFieldCheck = 0

			if(this.caseForm.enquiry_number == null || this.caseForm.enquiry_number == ''){
				this.$toast.error('Please specify an Order Number')
			}else{
				reqFieldCheck++
			}

			if(this.caseForm.patient_reference == null || this.caseForm.patient_reference == ''){
				this.$toast.error('Please specify a Patient Reference')
			}else{
				reqFieldCheck++
			}

			if(reqFieldCheck == 2){
				this.$inertia.post(`/admin/cases/${this.thisCase.hashid}`, this.caseForm)
			}
		},
		selectSetting(setting, allowed){
			if(allowed){
				this.selectedSetting = setting
			}
		},
	},
	computed: {
		enrichedSurgeons(){
			return (this.availableSurgeons || []).map(surgeon => {
				let case_relation = false

				const isEditor = Array.isArray(this.thisCase.editors) && this.thisCase.editors.find(e => e && e.id === surgeon.id)
				if(isEditor){
					case_relation = 'Supporting Surgeon'
				}
				const isViewer = Array.isArray(this.thisCase.viewers) && this.thisCase.viewers.find(e => e && e.id === surgeon.id)
				if(isViewer){
					case_relation = 'Viewer'
				}
				return {
					...surgeon,
					case_relation,
					disabled: case_relation ? true : false
				}
			})
		}
	}
}

</script>

<style scoped lang="sass">

// .case-settings



</style>